module.exports = __webpack_public_path__ + "img/header-engagementRingsSignature.b66e5b7.jpg";